<template>
  <main class="home">
    <header class="py-6 md:px-20 px-4 sm:px-6">
      <nav class="flex flex-row justify-between">
        <img class="w-20 sm:w-24 md:w-auto" :src="require('@/assets/img/logo.svg')" alt="" />
        <ul class="flex -ml-4">
          <li class="pl-4"><a href="">Login</a></li>
          <li class="pl-4"><a href="">Signup</a></li>
        </ul>
      </nav>
    </header>
    <section class="mt-12 md:mt-32">
      <div class="max-w-3xl mx-auto px-4">
        <h1 class="text-2xl md:text-3xl text-center leading-snug">
          Vibe up with amazing
          <span class="text-primary">unlimited</span> (limited-edition) products
          from FOMO store. Everything you see is
          <span class="text-primary">unique</span>, gets designed in real-time,
          and will be never seen again.
        </h1>
      </div>
    </section>
    <section class="mt-12 md:mt-32">
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-distance="500"
        class="items-start max-w-6xl mx-auto"
      >
        <div class="md:-ml-4 flex flex-wrap justify-center ">
           <tshirt :key="i" v-for="i in blobberCount" />
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// @ is an alias to /src

import Tshirt from "@/components/Tshirt";

export default {
  name: "Home",
  components: {
    Tshirt
  },
  data() {
    return {
      blobberCount: 12,
      busy: false,
    };
  },
  methods: {
    loadMore: function () {
      this.blobberCount += 12;
    },
  },
};
</script>
